import { hasReadPermission } from "@/auth/utils";

const account_menus = {
  title: 'Ad Account',
  icon: 'ActivityIcon',
  tagVariant: 'light-warning',
  children: [
    {
      title: 'Ad Account Info',
      icon: 'ClipboardIcon',
      route: {
        path: '/account-info'
      },
    }
  ]
};

if (hasReadPermission("users")) {
  account_menus.children.push({
    title: 'Ad Account Users',
    icon: 'UsersIcon',
    route: {
      path: '/account-users'
    },
  });
}

export default [account_menus];
